var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolidArrowRightFromBracket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176.5 388.5H123.5C108.864 388.5 97 376.635 97 362V150C97 135.365 108.864 123.5 123.5 123.5H176.5C191.136 123.5 203 111.635 203 97C203 82.3654 191.136 70.5 176.5 70.5H123.5C79.5928 70.5 44 106.093 44 150V362C44 405.907 79.5928 441.5 123.5 441.5H176.5C191.136 441.5 203 429.635 203 415C203 400.365 191.136 388.5 176.5 388.5ZM460.236 237.264L354.236 131.264C343.878 120.905 327.109 120.919 316.764 131.264C306.412 141.615 306.412 158.385 316.764 168.736L377.527 229.5H203C188.352 229.5 176.5 241.352 176.5 256C176.5 270.648 188.352 282.5 203 282.5H377.527L316.764 343.264C306.412 353.615 306.412 370.385 316.764 380.736C327.115 391.088 343.885 391.088 354.236 380.736L460.236 274.736C470.588 264.385 470.588 247.615 460.236 237.264Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidArrowRightFromBracket);
export default __webpack_public_path__ + "static/media/solid_arrow-right-from-bracket.1e030d65eb50f18401d2a7c98dedc085.svg";
export { ForwardRef as ReactComponent };